/*  *** PWP CONFIG ***
 * • Add new PwP offer to beginning of list
 * • If product is not capped at a specific quantity, set capQuantity: null
 * • If requiredQuantity is not provided, it will default to 6
 */
export const pwpConfig = [
  {
    productId: '4f3661e6-9d11-43bc-872e-6f4cc1df744f',
    ldFlag: 'juneMixedPackPwp2021',
    capQuantity: 1,
    requiredQuantity: 12,
    mixedPackText: 'Birthday Bundle',
    description: 'Gift with Purchase! Add them to your cart now.',
    subDescription: '*Must purchase 12+ bottles. Offer available through 06/31/21',
  },
  {
    productId: '7e86bc10-4203-4078-a006-ba8394422f20',
    ldFlag: 'mayMixedPackPwp2021',
    capQuantity: 2,
    mixedPackText: 'Cause Pack',
    description: 'Try our limited-edition Cause Pack at 50% off!',
    subDescription: '*Offer available through 05/31/21',
  },
  {
    productId: '92c0709c-55d8-421b-a673-dc24d020ec81',
    ldFlag: 'aprilMixedPackPwp2021',
    capQuantity: 2,
    mixedPackText: 'Roots Pack',
    description: 'Try our limited-edition Roots Pack at 50% off!',
    subDescription: '*Offer available through 04/30/21',
  },
  {
    productId: '16dd99f3-5a31-43ac-832a-243579fedb15',
    ldFlag: 'marchMixedPackPwp',
    capQuantity: 2,
    mixedPackText: 'HerStory Pack',
    description: 'Try our limited-edition HerStory Pack at 50% off!',
    subDescription: '*Offer available through 03/31/21',
  },
  {
    productId: '676bc92a-1b38-4a16-8ff1-ea76936e136b',
    ldFlag: 'februaryMixedPackPwp',
    capQuantity: 2,
    mixedPackText: 'Love Pack',
    description: 'Try our limited-edition Love Pack at 50% off!',
    subDescription: '*Offer available through 02/28/21',
  },
  {
    productId: 'c3d0aa33-6560-42b3-82ef-136669aeef9d',
    ldFlag: 'januaryMixedPackPwp',
    capQuantity: 2,
    mixedPackText: 'Winning Wines Pack',
    description:
      'Try our limited edition Winning Wines Pack featuring three 90+ point wines at 50% off!',
    subDescription: '*Offer available through 01/31/21',
  },
  {
    productId: '9bf289dd-bc38-4afb-9d9c-3db90875d9d6',
    ldFlag: 'decemberMixedPackPwp',
    capQuantity: 2,
    mixedPackText: 'Milestone Mixed Pack',
    description: 'Try our limited edition Milestone Mixed Pack at 50% off!',
    subDescription: '*Offer available through 12/31/20',
  },
  {
    productId: '89f94a2b-72f1-4c7b-adb9-e1181663878d',
    ldFlag: 'novemberMixedPackPwp',
    capQuantity: 2,
    mixedPackText: 'Holiday Hope Pack',
    description: 'Try our limited edition Holiday Hope Pack at 50% off!',
    subDescription: '*Offer available through 11/30/20',
  },
  {
    productId: 'e4c74c94-b969-42cd-95cb-179bd5306c14',
    ldFlag: 'octoberMixedPackPwp',
    capQuantity: 1,
    mixedPackText: 'Breast Friend Trio',
    description: 'Try our limited edition Breast Friend Trio at 40% off!',
    subDescription: '*Offer available through 10/31/20',
  },
  {
    productId: '4d48e61f-87a2-4187-a225-23eb051e88c7',
    ldFlag: 'septemberMixedPackPwp',
    capQuantity: 1,
    mixedPackText: 'Endless Summer Duo',
    description: 'Try our limited edition Endless Summer Duo over $40 off!',
    subDescription: '*Offer available through 9/30/20',
  },
  {
    productId: 'bc47e019-35a8-4eeb-96e8-cc36f853b5cc',
    ldFlag: 'augustMixedPackPwp',
    capQuantity: 1,
    mixedPackText: 'Frosé & Friends Pack',
    description: 'Try our limited edition Frosé & Friends Pack at 40% off!',
    subDescription: '*Offer available through 8/31/20',
  },
  {
    productId: 'f48e88e3-a34f-4055-87ef-d225897d3e00',
    ldFlag: 'julyMixedPackPwp',
    capQuantity: 1,
    mixedPackText: '3-pack',
    description: 'Try our limited edition Sunkissed Sips 3-pack at 50% off!',
    subDescription: '*Offer available through 7/31/20',
  },
  {
    productId: 'cf950e4b-8719-4a85-a337-d099d852a0bd',
    ldFlag: 'juneMixedPackPwp',
    capQuantity: null,
    mixedPackText: '2-pack',
    description:
      'Try our limited edition Pour with Pride 2-Pack! $5 shipping until June 30 at 11:59pm PST!',
    subDescription: '',
  },
];

export const purchaseWithPurchaseProductIds = pwpConfig.map(
  pwp => pwp && pwp.productId,
);
